<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/kja7XV/tc-custom/9780830874101.jpg?1696873918231" alt="This image is the cover for the book Window on the World, Operation World Resources"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Window on the World, Operation World Resources
      </h1>
      <p class="bookDescription body article font2">
        <p> <em>Window on the World</em> is your ticket to travel around the world! If you appreciate <em>Operation World</em> as an adult, your kids will love this invaluable and age-appropriate prayer resource that develops cultural, political, and geographical awareness through a Christian lens. Find out how God is changing the lives of families everywhere through prayer—from the frozen Arctic to the hottest desert, on the highest mountains and in crowded cities.</p> <p> <em>Window on the World</em> brings alive the culture, history, and traditions of all sorts of different people. With "Fact Files" and "Do You Know?" features, each section brings you information, true stories, maps, and easy-to-use prayer points that take you into homes around the world. See how children live, what they like to do, where they go to school, what they eat and wear, and what they hope and dream.</p> <p>This revised edition includes new entries for more countries and people groups, with updated information and prayer points from the team at Operation World. It will draw a new generation into learning about the world, reaching out to people, and praying for those who have never heard about Jesus. Through <em>Window on the World</em>, young people and adults alike can discover and pray for the peoples of the world.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Molly Wall, Jason Mandryk
      </h2>
      
      <p class="authorDescription body article"><p>Molly Wall is a researcher, editor and program director with Operation World, a ministry of WEC International, and is based near London in the UK. She is one of the principal catalysts and researchers behind the latest edition of <em>Operation World</em> and <em>Pray for the World,</em> informing Christians worldwide how they can pray for the nations. Molly came aboard the Operation World team in 2009 after seven years at the U.S. Center for World Mission in Pasadena, California, where she served as a curriculum developer and researcher.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?61657116